'use strict';

/* global yith_wcaf */

import { $, block } from '../../../src/globals.js';
import YITH_WCAF_Admin_Modal from './yith-wcaf-admin-modal';

export default class YITH_WCAF_Admin_Info_Modal extends YITH_WCAF_Admin_Modal {
	onSubmit( ev ) {
		const $target = this.$target,
			$content = this.modal.elements.content,
			$wrapper = this.modal.elements.wrap,
			$form = $wrapper.find( 'form' );

		if ( ! $form.length ) {
			return;
		}

		// prevent default loading
		ev.preventDefault();

		// block content
		block( $content );

		const $targetForm = $target.closest( 'form' );

		// check for supported $opener types
		if ( $target.is( 'a' ) ) {
			let href = this.$target.attr( 'href' ),
				url = new URL( href ),
				query = url.searchParams;

			// build new query string
			$form.find( ':input' ).each( function () {
				const $field = $( this ),
					name = $field.attr( 'name' );

				if ( ! name ) {
					return;
				}

				query.append( name, $field.val() );
			} );

			// set new query string to destination url
			url.search = query;

			// redirect to destination url
			window.location = url.href;
		} else if (
			$target.is( 'input[type="submit"]' ) &&
			$targetForm.length
		) {
			// append current form content to target form content
			$form.find( ':input' ).each( function () {
				const $field = $( this ),
					name = $field.attr( 'name' );

				if ( ! name ) {
					return;
				}

				const $newField = $( '<input>', {
					type: 'hidden',
					name,
					value: $field.val(),
				} );

				$targetForm.append( $newField ).submit();
			} );
		}
	}
}
